import { render, staticRenderFns } from "./dashboard-sale-hot-rank.vue?vue&type=template&id=cd96990e&scoped=true&"
import script from "./dashboard-sale-hot-rank.vue?vue&type=script&lang=js&"
export * from "./dashboard-sale-hot-rank.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-sale-hot-rank.vue?vue&type=style&index=0&id=cd96990e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd96990e",
  null
  
)

export default component.exports